import { combineReducers } from 'redux';

import { ACTION_SWITCH_LEFT_MENU } from '../actionTypes';


const isLeftMenuOpened = (state = false, action) => {
  switch (action.type) {
    case ACTION_SWITCH_LEFT_MENU:
      return action.payload.isShow === null ? !state : action.payload.isShow;

    default:
      return state;
  }
};

export default combineReducers({
  isLeftMenuOpened,
});
